import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern Living kit — decor: a large floor plant (~1.5 m tall). A big
// terracotta pot, a short trunk and four leaf clumps spread outward.
const POT = "#a05a40";
const SOIL = "#4a3a2a";
const TRUNK = "#7a5a3a";
const LEAF = "#5f8f4e";
const LEAF_LIGHT = "#6f9f5c";
const LEAF_DARK = "#4f7a40";

export const houseplantLarge = defineModel({
  id: "houseplant-large",
  batchId: "modern",
  name: "Houseplant (large)",
  tags: ["modern", "interior", "decor", "plant", "houseplant"],
  summary: "A large floor plant in a terracotta pot.",
  tiles: { w: 1, h: 1 },
  footprint: 1.1,
  parts(): Part[] {
    return [
      // tapered terracotta pot
      { geometry: new THREE.CylinderGeometry(0.22, 0.16, 0.36, 12), color: POT, position: [0, 0.18, 0] },
      // soil disc
      { geometry: new THREE.CylinderGeometry(0.19, 0.19, 0.03, 12), color: SOIL, position: [0, 0.37, 0] },
      // short trunk
      { geometry: new THREE.CylinderGeometry(0.035, 0.045, 0.6, 8), color: TRUNK, position: [0, 0.66, 0] },
      // leaf clumps spread outward
      { geometry: new THREE.IcosahedronGeometry(0.3, 0), color: LEAF, position: [0, 1.28, 0] },
      { geometry: new THREE.IcosahedronGeometry(0.24, 0), color: LEAF_LIGHT, position: [0.24, 1.06, 0.12] },
      { geometry: new THREE.IcosahedronGeometry(0.22, 0), color: LEAF_DARK, position: [-0.22, 1.1, -0.1] },
      { geometry: new THREE.IcosahedronGeometry(0.2, 0), color: LEAF, position: [-0.06, 1.0, 0.22] },
    ];
  },
  animations: [],
});
